import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Apenas o Dashboard precisa saber do Auth
import { motion, AnimatePresence } from 'framer-motion';

import Sidebar from '../components/Sidebar';
import ServicesManager from '../components/ServicesManager';
import ProdutosManager from '../components/ProdutosManager';
import HorariosManager from '../components/HorariosManager';
import FaqManager from '../components/FaqManager';
import Caixa from '../components/Caixa';
import AgendaManager from '../components/AgendaManager';
import './Dashboard.css';

const DashboardPage = () => {
  const { user, signOut } = useAuth(); // Pega o usuário e a função de logout aqui
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState('caixa');

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  const renderActiveView = () => {
    switch (activeView) {
      case 'caixa': return <Caixa />;
      case 'agenda': return <AgendaManager />;
      case 'servicos': return <ServicesManager />;
      case 'produtos': return <ProdutosManager />;
      case 'horarios': return <HorariosManager />;
      case 'faq': return <FaqManager />;
      default: return <Caixa />;
    }
  };

  return (
    <div className="app-layout">
      {/* Passamos o email do usuário e a função de logout como props */}
      <Sidebar 
        activeView={activeView} 
        setActiveView={setActiveView}
        userEmail={user?.email}
        onLogout={handleLogout}
      />
      <main className="main-content">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeView}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
          >
            {renderActiveView()}
          </motion.div>
        </AnimatePresence>
      </main>
    </div>
  );
};

export default DashboardPage;